import { makeStyles, createStyles, MuiTheme } from '@kis-technologies/kis-ui';

export const useStyles = makeStyles((theme: MuiTheme) =>
  createStyles({
    maintenanceOuterContainer: {
      overflow: 'hidden',
      borderRadius: '32px',
      background: 'white',
      height: '842px',
      color: '#2A2A2A',
      minWidth: '100%',
      [theme.breakpoints.down('lg')]: {
        height: '1750px',
        borderRadius: '8px'
      },
      [theme.breakpoints.only('lg')]: {
        height: '875px'
      }
    },
    maintenanceTabContainer: {
      width: '12.75%',
      height: '100%',
      borderRight: '1px solid #DDDDDD',
      justifyContent: 'space-between',
      display: 'flex',
      [theme.breakpoints.down('lg')]: {
        display: 'none'
      }
    },
    maintenancePortraitTabContainer: {
      display: 'none',
      [theme.breakpoints.down('lg')]: {
        display: 'flex',
        width: '100%',
        height: '70px',
        borderBottom: '1px solid #DDDDDD',
        '& > * > span': {
          top: '6px',
          height: '71px',
          width: '120px',
          left: '39px',
          borderBottom: '10px solid #f46d2e',
          borderRight: 'none'
        },
        '& > * > button': {
          fontSize: '24px',
          borderLeft: '10px solid transparent'
        }
      }
    },
    maintenancePortraitLogoutBlock: {
      display: 'none',
      [theme.breakpoints.down('lg')]: {
        width: '100%',
        alignItems: 'center',
        display: 'flex'
      }
    }
  })
);
